import { useEffect } from 'react';
import { updateEdges } from '../helpers/updateEdges';
import { updateNodes } from '../helpers/updateNodes';

// Handles graph state updates whenever the graph changes.
// Uses a 50ms debounce so rapid setGraph calls (e.g. during PDF page processing)
// are coalesced into a single DataSet update.
export function useHandleGraphUpdates(graph, networkRef, useHandleGraphUpdatesTimerRef) {

  useEffect(() => {
    if (useHandleGraphUpdatesTimerRef.current) {
      clearTimeout(useHandleGraphUpdatesTimerRef.current);
    }

    useHandleGraphUpdatesTimerRef.current = setTimeout(() => {
      try {
        if (!graph) {
          if (networkRef.current) {
            networkRef.current.body.data.nodes.clear();
            networkRef.current.body.data.edges.clear();
          }
          return;
        }
        updateNodes(graph, networkRef);
        updateEdges(graph, networkRef);
      } catch (error) {
        console.error(error);
      }
      useHandleGraphUpdatesTimerRef.current = undefined;
    }, 50);

    return () => {
      if (useHandleGraphUpdatesTimerRef.current) {
        clearTimeout(useHandleGraphUpdatesTimerRef.current);
      }
    };
  }, [graph, networkRef, useHandleGraphUpdatesTimerRef]);
}
